import React from "react";
import { Database, Clock, CheckCircle2, AlertTriangle } from "lucide-react";
import { formatDate } from "@/lib/api";

const JOB_LABEL = {
  itsync: "Income Tax (12A/80G)",
  fcra: "FCRA (MHA)",
  darpan: "NGO Darpan",
  ngomap: "Entity Mapping",
};

const STATUS_DOT = {
  success: "bg-emerald-500",
  stale: "bg-amber-500",
  failed: "bg-rose-500",
};

export default function FreshnessPanel({ jobs = [], compact = false }) {
  return (
    <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
      {jobs.map((j) => (
        <div
          key={j.job}
          data-testid={`freshness-${j.job}`}
          className="rounded-xl border border-slate-800 bg-slate-900/70 p-4 backdrop-blur-sm"
        >
          <div className="flex items-center justify-between">
            <span className="flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-widest text-slate-400">
              <Database className="w-3 h-3" /> {JOB_LABEL[j.job] || j.job}
            </span>
            <span className={`h-2 w-2 rounded-full ${STATUS_DOT[j.status] || "bg-slate-500"}`} />
          </div>
          <div className="mt-2 flex items-baseline gap-2">
            <span className="font-mono text-lg font-semibold text-slate-100">{formatDate(j.freshness)}</span>
            {j.status === "stale" ? (
              <span className="inline-flex items-center gap-1 text-[10px] text-amber-600">
                <AlertTriangle className="w-3 h-3" /> stale
              </span>
            ) : (
              <span className="inline-flex items-center gap-1 text-[10px] text-emerald-600">
                <CheckCircle2 className="w-3 h-3" /> fresh
              </span>
            )}
          </div>
          {!compact && (
            <p className="mt-1 flex items-center gap-1 text-[11px] text-slate-500">
              <Clock className="w-3 h-3" /> {j.records?.toLocaleString?.() || j.records} records
            </p>
          )}
        </div>
      ))}
    </div>
  );
}
